import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import TableVersionMobileComponent from 'components/Content/ManageAccount/VersionMobile/VersionMobileComponent';
import ModalStatus from 'materials/ModalStatus';
import { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getHistoryVersionApp, updateHistoryVersionApp } from 'services/VersionMobileService';
import * as ActionNavigation from '../../../../core/action/Router/ActionRouter';
import * as toggle from '../../../../core/action/toggle';
import React from 'react';

interface IProps {
  actionNavigation: any;
  actionToggle: any;
}
const VersionMobileContainer = (props: IProps) => {
  const [searchGroup, setSearchGroup] = useState<string>('');
  const [page, setPage] = useState<number>(1); // start 1
  const itemPerPage = 10;

  const { data: listHistoryVersion, isLoading, isFetching, refetch } = useQuery<AxiosResponse, Error>({
    queryKey: ['listHistory',],
    queryFn: () => getHistoryVersionApp(),
    refetchOnWindowFocus: false,
  })

  const handlePage = (newPage: number) => {
    setPage(newPage);
  };

const filteredData = useMemo(() => {
  const allData = listHistoryVersion?.data || [];
  const filtered = allData.filter(item =>
    item.timestamp?.toLowerCase().includes(searchGroup.toLowerCase()) ||
    item.actor?.toLowerCase().includes(searchGroup.toLowerCase()) ||
    item.version?.toLowerCase().includes(searchGroup.toLowerCase())
  );
  return filtered;
}, [listHistoryVersion, searchGroup]);

const paginatedData = useMemo(() => {
  const start = (page - 1) * itemPerPage;
  const end = start + itemPerPage;
  return filteredData.slice(start, end);
}, [filteredData, page]);


  const handleModal = () => {
    props.actionToggle.changeModal();
    props.actionToggle.changeJenisToggle('AddVersionMobile');
  };

  const updateHistoryVersion = useMutation(updateHistoryVersionApp, {
    onSuccess(data, variables) {
      refetch()
    },
    onError(error: any) {
      ModalStatus({
        status: 'error',
        title: 'Internal Server Error',
        content: 'Silahkan Hubungi Admin',
      });
    }
  })

  const onSubmitUpdate = (value: any) => {
    updateHistoryVersion.mutate(value)
  }
  return (
    <TableVersionMobileComponent
      data={paginatedData}
      PagePagination={page}
      TotalPagePagination={Math.ceil(filteredData.length / itemPerPage)}
      handlePage={handlePage}
      handleSearchName={() => { }}
      handleUpdate={onSubmitUpdate}
      handleModal={handleModal}
      searchGroup={searchGroup}
      isLoading={isLoading || isFetching}
      handleSearchGroup={value => {
        setSearchGroup(value);
        setPage(1); // reset ke page 1 kalau search berubah
      }}
      refetch={refetch}
    />
  );
};

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  actionToggle: bindActionCreators(toggle, dispatch),
  actionNavigation: bindActionCreators(ActionNavigation, dispatch),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(VersionMobileContainer);
